<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <h3 class="pt-0 pb-4">Data View Preferences Admin</h3>
          <form id="userPreferencesAdminForm" role="form" [formGroup]="userPreferencesAdminForm">

            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="screen_name">Screen Name<small class="required">*</small></label>
                <select id="screen_name" class="w-100" formControlName="screenName"
                  (change)="screenNameChange($event)" required>
                  <option value='null' selected disabled>Choose...</option>
                  <option value="HHGResults">HHG Query Preferences</option>
                  <!-- <option value="FRTResults">FRT Query Preferences</option>
                  <option value="HHGShipments">HHG Shipments</option>
                  <option value="FRTShipments">FRT Shipments</option> -->
                  <option value="HHGIffMaster">HHG IFF Summary Preferences</option>
                </select>
              </div>
            </div>
            @for (pref of userPrefList; track pref; let i = $index) {
              <div class="form-check form-check-inline">
                <label>
                  <input type="checkbox" [checked]="pref.isVisible"
                    (change)="onCheckboxChange(pref.headerName,$event.target.checked)" />
                  {{pref.headerName}}
                </label>
              </div>
            }
            <div>
              @if (saveBtnDisable) {
                <button type="button" class="btn btn-primary w-auto ml-4"
                (click)="savePref()">Save Preferences</button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
